import { render, staticRenderFns } from "./ClientAlert.vue?vue&type=template&id=5aa8c6bd&"
import script from "./ClientAlert.vue?vue&type=script&lang=js&"
export * from "./ClientAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports